/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const formResponsesState = {
    form_guid: undefined,
    form: undefined,
    responses: [],
    rows: [],
    vizType: "table",
    selectedQuestions: []
};
